import { useParams } from 'react-router-dom';
import { ChatApiProvider } from '../Services/ChatApiProvider';
import App from '../App';

const ChatRoute = () => {
  const { channelId } = useParams();

  return (
    <ChatApiProvider>
      <App />
    </ChatApiProvider>
  );
};

export default ChatRoute;
